import { Component, Input } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-logo-color',
  templateUrl: './logo-color.component.html',
  styleUrls: ['./logo-color.component.scss']
})
export class LogoColorComponent {
  @Input() height: string = "1rem";
  // @Input() color: string = "#001f54";
  @Input() theme: string = "#001f54";
  logoSrc = 1;

  constructor(private themeService: ThemeService) {}

  ngOnInit() {
    this.setLogoByTheme(this.themeService.getCurrentTheme());
  }

  private setLogoByTheme(theme: string | null) {
      switch (theme) {
        case 'blue-theme':
          this.logoSrc = 1;
          break;
        case 'green-theme': //Extracciones
          this.logoSrc = 2;
          break;
        case 'yellow-theme':  //Alfa y Omega
          this.logoSrc = 3;
          break;
        case 'food-theme':  // Alimentos
          this.logoSrc = 4;
          break;
        default:
          this.logoSrc = 1;
      }
    }
}
